import Client from 'components/modals/events/result/forms/xml/Client';
import PhoneContact from 'components/modals/events/result/forms/xml/PhoneContact';
import EmplInterview from 'components/modals/events/result/forms/xml/EmplInterview';
import VerificateRecomendation from 'components/modals/events/result/forms/xml/VerificateRecomendation';
import SomeFormMain from 'components/modals/events/result/forms/xml/SomeFormMain';
import Marketing from 'components/modals/events/result/forms/xml/Marketing';

export const CONTACT = 'PplPhoneInterv';
export const INTERVIEW_RECRUTER = 'PplInterv';
export const INTERVIEW_CONTACT = 'PplZakInterv';
export const VERIFICATE_RECOMENDATION = 'PplVerRek';
export const PROJECT_SOME_FORM = 'PrjSomeForm';
export const ORG_SOME_FORM = 'OrgSomeForm';
export const RESPONSE = 'PplAnketa';
export const MARKETING = 'OrgMrktCallData';

export const xmlFields = {
    [INTERVIEW_CONTACT]: Client,
    [CONTACT]: PhoneContact,
    [INTERVIEW_RECRUTER]: EmplInterview,
    [VERIFICATE_RECOMENDATION]: VerificateRecomendation,
    [PROJECT_SOME_FORM]: SomeFormMain('project'),
    [ORG_SOME_FORM]: SomeFormMain('company'),
    [MARKETING]: Marketing,
};
